import React from 'react'
import Header from '../components/Header/Header'
import Article from '../components/Section_Article/Article'

export default function Article_page() {
  return (
    <div>
    <Article_page/>
    </div>
  )
}
